export default __webpack_public_path__ + "assets/b8bf5f689505c3effd9b529855b364bb.jpeg";